import { render, staticRenderFns } from "./GrantAccessToAllUsersConfirmation.vue?vue&type=template&id=37a8333f&scoped=true"
import script from "./GrantAccessToAllUsersConfirmation.vue?vue&type=script&lang=js"
export * from "./GrantAccessToAllUsersConfirmation.vue?vue&type=script&lang=js"
import style0 from "./GrantAccessToAllUsersConfirmation.vue?vue&type=style&index=0&id=37a8333f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8333f",
  null
  
)

export default component.exports